import datadogLogger from "@lib/datadogLogger";

/**
 * This function is used to post a message through a message port.
 */
export const postMessageWithMessagePort = <Message = unknown>(port: MessagePort | undefined, payload: Message) => {
  if (!port) {
    return;
  }

  try {
    port.postMessage(payload);
  } catch (error) {
    // The frontend uses RUM for monitoring. We report actions here so that we can generate metrics
    // from actions to understand how often they are happening.
    datadogLogger.userAction("post-message-with-message-port", {
      payload, // Log the payload to understand the context and what was being sent
      error, // Log the error to understand what went wrong
    });
    throw error;
  }
};
